import React, { useState, useEffect } from "react"
import { useLocation, Route, Routes, Navigate } from "react-router-dom"
import { Container } from "reactstrap"
// Custom rider components
import { RiderSidebar } from "../components/RiderSidebar"
import { AdminFooter } from "../components/AdminFooter"
// routes
import routes from "./routes.js"
import { Auth } from "../../utils/auth"

const RiderLayout = props => {
  const mainContent = React.useRef(null)
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  React.useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    if (mainContent.current) {
      mainContent.current.scrollTop = 0
    }
  }, [location])

  // Close sidebar when route changes (mobile)
  useEffect(() => {
    setSidebarOpen(false)
  }, [location.pathname])

  const getRoutes = routes => {
    const userRole = Auth.role()
    return routes.map((prop, key) => {
      if (prop.layout === "/admin" && prop.permissions.includes(userRole)) {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        )
      } else {
        return null
      }
    })
  }

  return (
    <div className="rider-layout">
      {/* Mobile Menu Button */}
      <button
        onClick={() => setSidebarOpen(true)}
        className={`rider-mobile-menu-btn ${sidebarOpen ? "hidden" : ""}`}
        aria-label="Open menu"
      >
        <i className="fas fa-bars"></i>
      </button>

      {/* Mobile Overlay */}
      <div
        className={`rider-mobile-overlay ${sidebarOpen ? "show" : ""}`}
        onClick={() => setSidebarOpen(false)}
      />

      {/* Sidebar */}
      <aside className={`rider-sidebar ${sidebarOpen ? "open" : ""}`}>
        <RiderSidebar routes={routes} onClose={() => setSidebarOpen(false)} />
      </aside>

      {/* Main Content Area */}
      <div className="rider-main-content">
        {/* Header for mobile */}
        <div className="rider-mobile-header">
          <h1>📦 Speedworks Rider</h1>
        </div>

        {/* Page Content */}
        <main className="rider-main-content-area" ref={mainContent}>
          <Routes>
            {getRoutes(routes)}
            <Route
              path="*"
              element={<Navigate to="/admin/rider-dashboard" replace />}
            />
          </Routes>
          <Container fluid className="mt-4">
            <AdminFooter />
          </Container>
        </main>
      </div>
    </div>
  )
}

export default RiderLayout
